import { SimNaoEnum } from 'components/form'
import { createValidator, ErrorObject, required } from 'util/validation'

import { PodeNaoPodeEnum } from '../../model-consultaSeguimento'
import { hasAnySim } from '../../utils-consultaSeguimento'
import { isStatusValid } from '../../validator-consultaSeguimento'
import { ConsultaSeguimentoPergunta18Model } from './model-consultaSeguimentoPergunta18'

export const validatorConsultaSeguimentoPergunta18 = createValidator<ConsultaSeguimentoPergunta18Model>(
  {
    resultado: required,
    status: isStatusValid,
    PERGUNTA_18_HEADER: required,
  },
  (values: ConsultaSeguimentoPergunta18Model, errors: ErrorObject<ConsultaSeguimentoPergunta18Model>) => {
    if (values?.PERGUNTA_18_HEADER === SimNaoEnum.SIM) {
      errors.PERGUNTA_18_PODE_NAO_PODE = required(values?.PERGUNTA_18_PODE_NAO_PODE)
    }

    if (
      values?.PERGUNTA_18_HEADER === SimNaoEnum.NAO ||
      (values?.PERGUNTA_18_HEADER === SimNaoEnum.SIM && values?.PERGUNTA_18_PODE_NAO_PODE === PodeNaoPodeEnum.NAO_PODE)
    ) {
      errors.PERGUNTA_18_TEM_DICA_SEGUE_ORDEM = required(values?.PERGUNTA_18_TEM_DICA_SEGUE_ORDEM)

      if (values?.PERGUNTA_18_TEM_DICA_SEGUE_ORDEM === SimNaoEnum.NAO) {
        errors.PERGUNTA_18_SENTA_A_MESA = required(values?.PERGUNTA_18_SENTA_A_MESA)
      }

      if (
        values?.PERGUNTA_18_TEM_DICA_SEGUE_ORDEM === SimNaoEnum.SIM ||
        values?.PERGUNTA_18_SENTA_A_MESA === SimNaoEnum.SIM
      ) {
        if (!hasAnySim(values?.PERGUNTA_18_EXEMPLOS)) {
          errors.PERGUNTA_18_EXEMPLOS = createValidator<ConsultaSeguimentoPergunta18Model['PERGUNTA_18_EXEMPLOS']>({
            SEM_DICA_MOSTRA_SAPATO: required,
            SEM_DICA_TRAZ_COBERTOR: required,
            SEM_DICA_POE_LIVRO_CADEIRA: required,
          })(values?.PERGUNTA_18_EXEMPLOS)
        }
      }
    }

    return errors
  }
)
